import {
  cancelShipmentsRequestSchema,
  SHIPMENT_CANCEL_NOTE,
  SHIPMENT_CANCEL_REASON_ID,
  type CancelShipmentsRequest,
} from './schema'

/** STT / shipment id the shipment service expects in `shipment_ids`. */
export function shipmentCancelId(order: { shipmentId: string | null; sttNo: string | null }) {
  return order.shipmentId?.trim() || order.sttNo?.trim() || null
}

export function buildCancelShipmentsBody(shipmentIds: readonly string[]): CancelShipmentsRequest {
  return cancelShipmentsRequestSchema.parse({
    shipment_ids: shipmentIds,
    reason_id: SHIPMENT_CANCEL_REASON_ID,
    note: SHIPMENT_CANCEL_NOTE,
  })
}
